/** Máximo por línea en carrito/checkout para productos dropshipping (inventario inicial). */
export const DROPSHIPPING_MAX_QUANTITY = 10;
